import { render } from "./VCurrencyText.vue?vue&type=template&id=76706d0d"
import script from "./VCurrencyText.vue?vue&type=script&lang=js"
export * from "./VCurrencyText.vue?vue&type=script&lang=js"

import "./VCurrencyText.vue?vue&type=style&index=0&id=76706d0d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__